// extracted by mini-css-extract-plugin
export default {"dailyForecast":"style_dailyForecast__svp-x"};